/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps, useFieldHelper } from 'framework/ui/field';
import { EXPENSE_SUBTYPES, SUBTYPE_FIELD_LABELS } from 'domain/shared/expense';

const ExpenseSubTypeField = ({ typeSource, source, ...props }: FieldProps & { typeSource: string }) => {
  const { getValue: getType } = useFieldHelper({ source: typeSource });
  const type = getType() as any;
  const options = EXPENSE_SUBTYPES[type];
  const label = SUBTYPE_FIELD_LABELS[type];

  return <EnumField options={options || {}} {...props} source={source} label={label} />;
};

export default ExpenseSubTypeField;
